import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import { FormControl } from "material-ui/Form";
import { MenuItem } from "material-ui/Menu";
import { default as ReactDatePicker, registerLocale } from 'react-datepicker'
import moment from 'moment';
import ja from 'date-fns/locale/ja';
import DialogModal from './DialogModal';

import "react-datepicker/dist/react-datepicker.css";
import "../../assets/css/react-datepicker.custom.css";

ja.options.weekStartsOn = 0;
registerLocale('ja', ja);

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '800px',
  },

  contentContainer: {
    padding: '25px',
    margin: 0,
  },

  dateSelectContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: "25px",
    alignItems: 'center',
  },

  box: {
    textAlign: 'start',
  },

  buttonContainer: {
    marginTop: 40,
    display: "flex",
    width: "100%",
    justifyContent: "center",
  },

  button: {
    width: '200px',
    height: '40px',
    color: "#FFFFFF",
    background: '#2E68F6',
    fontSize: 15,
    '&:hover': {
      backgroundColor: '#1A65FF',
      opacity: .6,
    }
  },

  buttonDisabled: {
    width: '200px',
    height: '40px',
    color: "#FFFFFF",
    background: '#A2A2A2',
    fontSize: 15
  },

  markInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFFFFF',
    padding: '17px',
    fontSize: 11,
  },

  flex: {
    display: 'flex',
    alignItems: 'center',
  },

  circle: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: '#2E68F6',
    margin: 'auto 5px',
  },
});

class DateRangePickerDialog extends React.Component {
  state = {
    startDate: '',
    endDate: '',
    startYear: -1,
    startMonth: -1,
    startDay: -1,
    endYear: -1,
    endMonth: -1,
    endDay: -1,
    ownOrder: null,
    otherOrder: null,
  };

  componentDidMount() {
    const { orderList, user, isExe, dialogType } = this.props;
    let startYear = -1;
    let startMonth = -1;
    let startDay = -1;
    let endYear = -1;
    let endMonth = -1;
    let endDay = -1;
    let startDate = this.props.from ? new Date(this.props.from) : '';
    let endDate = this.props.to ? new Date(this.props.to) : '';
    let ownOrder = null;
    let otherOrder = null;

    if (startDate) {
      let momentStartDate = moment(startDate);
      startYear = momentStartDate.year();
      startMonth = momentStartDate.month() + 1; // 0から始まる数値のため+1する
      startDay = momentStartDate.date();
    }
    if (endDate) {
      let momentEndDate = moment(endDate);
      endYear = momentEndDate.year();
      endMonth = momentEndDate.month() + 1; // 0から始まる数値のため+1する
      endDay = momentEndDate.date();
    }

    // 自分の注文とチームの注文を抽出する
    if (orderList && user && (user.ownership_authority_flag || user.parent_id)) {
      if (dialogType.includes('follow_call_order')) {
        // フォローコール依頼済みの日付範囲選択の場合
        ownOrder = this.props.orderList.filter(item => item.ownership_user.id === user.id);
        otherOrder = this.props.orderList.filter(item => item.ownership_user.id !== user.id);
      } else {
        // isExeがtrueの場合はis_exeが1のデータを、falseの場合はis_exeが0のデータをフィルタリングする
        const isExeFilter = isExe ? item => item.is_exe === 1 : item => item.is_exe === 0;
        ownOrder = this.props.orderList.filter(item => item.order_contact.user_id === user.id && isExeFilter(item));
        otherOrder = this.props.orderList.filter(item => item.order_contact.user_id !== user.id && isExeFilter(item));
      }
    }

    this.setState({
      ownOrder: ownOrder,
      otherOrder: otherOrder,
      startDate: startDate,
      endDate: endDate,
      startYear: startYear,
      startMonth: startMonth,
      startDay: startDay,
      endYear: endYear,
      endMonth: endMonth,
      endDay: endDay,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.startYear !== this.state.startYear || prevState.startMonth !== this.state.startMonth || prevState.startDay !== this.state.startDay) {
      if (this.state.startYear !== -1 && this.state.startMonth !== -1 && this.state.startDay !== -1) {
        const startDate = new Date(this.state.startYear + '-' + this.state.startMonth + '-' + this.state.startDay);
        // 選択された開始日付が終了日付より後の場合は終了日時に開始日付を設定する
        if (this.state.endDate && this.state.endDate.getTime() < startDate.getTime()) {
          this.setState({
            startDate: startDate,
            endYear: startDate.getFullYear(),
            endMonth: startDate.getMonth() + 1, // 0から開始されるため+1する
            endDay: startDate.getDate(),
            endDate: startDate,
          });
        } else {
          if (!(this.state.startDate && this.state.startDate.getTime() === startDate.getTime())) {
            this.setState({
              startDate: startDate,
            });
          }
        }
      }
    }
    if (prevState.endYear !== this.state.endYear || prevState.endMonth !== this.state.endMonth || prevState.endDay !== this.state.endDay) {
      if (this.state.endYear !== -1 && this.state.endMonth !== -1 && this.state.endDay !== -1) {
        const endDate = new Date(this.state.endYear + '-' + this.state.endMonth + '-' + this.state.endDay);
        // 選択された終了日付が開始日付より後の場合は開始日時に終了日付を設定する
        if (this.state.startDate && this.state.startDate.getTime() > endDate.getTime()) {
          this.setState({
            startDate: endDate,
            startYear: endDate.getFullYear(),
            startMonth: endDate.getMonth() + 1, // 0から開始されるため+1する
            startDay: endDate.getDate(),
            endDate: endDate,
          });
        } else {
          if (!(this.state.endDate && this.state.endDate.getTime() === endDate.getTime())) {
            this.setState({
              endDate: endDate,
            });
          }
        }
      }
    }
  }

  handleFilter = () => {
    const { dialogType } = this.props;
    if (this.state.startDate && this.state.endDate) {
      this.props.dataRangeFilterSet({
        [dialogType + '_from']: moment(this.state.startDate).format('YYYY-MM-DD'),
        [dialogType + '_to']: moment(this.state.endDate).format('YYYY-MM-DD'),
      }, dialogType)
    }

    this.props.toggleDialog()
  }

  handleChange = (date) => {
    // 開始日時が選択されていない場合は開始日時を設定
    if (!this.state.startDate) {
      this.setState({
        startDate: date,
        startYear: date.getFullYear(),
        startMonth: date.getMonth() + 1, //０から開始されるため+1する
        startDay: date.getDate(),
      });
      // 開始日時が選択済みで終了日時が選択されていない、選択された日時が開始日時より後の場合は終了日時を設定
    } else if (this.state.startDate && !this.state.endDate && this.state.startDate.getTime() < date.getTime()) {
      this.setState({
        endDate: date,
        endYear: date.getFullYear(),
        endMonth: date.getMonth() + 1, //０から開始されるため+1する
        endDay: date.getDate(),
      });
      // 日付範囲が選択済みまたは選択された日時が開始日時より前の場合は開始日時を設定、終了日時は空に設定
    } else if (
      (this.state.startDate && this.state.endDate) ||
      (this.state.startDate && this.state.startDate.getTime() > date.getTime())
    ) {
      this.setState({
        startDate: date,
        startYear: date.getFullYear(),
        startMonth: date.getMonth() + 1, //０から開始されるため+1する
        startDay: date.getDate(),
        endDate: '',
        endYear: -1,
        endMonth: -1,
        endDay: -1,
      });
    }
  }

  handleItemSelected = (property, value) => {
    this.setState({
      [property]: value,
    });
  }

  // 日付のセレクトボックスの配列を生成する
  createDaysArray = (type) => {
    let dayCount, days;

    // 日付選択のセレクトボックスで年と月が指定されている場合は指定月の日数の配列を生成
    if (this.state[type + 'Year'] !== -1 && this.state.startMonth !== -1) {
      dayCount = moment(this.state.startYear + '-' + this.state[type + 'Month'], "YYYY-MM").daysInMonth();
      days = [...Array(dayCount)].map((_, i) => i + 1);

      // 日付選択のセレクトボックスで月が指定されている場合は指定月の日数の配列を生成
    } else if (this.state[type + 'Year'] === -1 && this.state[type + 'Month'] !== -1) {
      const now = moment();
      const year = now.year();
      dayCount = moment(year + '-' + this.state[type + 'Month'], "YYYY-MM").daysInMonth();
      days = [...Array(dayCount)].map((_, i) => i + 1);

      // 日付選択のセレクトボックスで月が指定されていない場合は31日までのの配列を生成
    } else {
      const maxDayCount = 31;
      days = [...Array(maxDayCount)].map((_, i) => i + 1);
    }

    return days;
  }

  renderSelectBox = (items, dateText, property) => {
    const { classes } = this.props;
    const addMarginRight = 10;
    const yearWidth = 140;
    const notYearWidth = 80;
    return (
      <FormControl
        className={classes.formControl}
        style={{ marginRight: dateText === '日' ? 0 : addMarginRight }}
      >
        <Select
          value={this.state[property]}
          onChange={e => this.handleItemSelected(property, e.target.value)}
          style={{ width: dateText === '年' ? yearWidth : notYearWidth, color: this.state[property] === -1 ? '#A2A2A2' : '#181819' }}
        >
          {this.state[property] === -1 && (
            <MenuItem className={classes.select} key={-1} value={-1}>
              {dateText}
            </MenuItem>
          )}
          {items.map((item, i) => (
            <MenuItem key={i} value={item}>
              {item}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }

  // 親子アカウントの場合で自分以外の日付に丸ぽちを追加
  addDayClassName = (date) => {
    if (!this.state.otherOrder) {
      return;
    }

    const dateFormat = moment(date).format('YYYY-MM-DD');
    let hasOwnOrder, hasOtherOrder;

    const subStringLength = 10;
    if (this.props.dialogType.includes('follow_call_order')) {
      // 自分以外の依頼日に丸ぽちを追加
      hasOwnOrder = this.state.ownOrder.find(
        item => item.created_at && item.created_at.substring(0, subStringLength) === dateFormat
      )
      hasOtherOrder = this.state.otherOrder.find(
        item => item.created_at && item.created_at.substring(0, subStringLength) === dateFormat
      )
    } else {
      // 自分以外の注文日に丸ぽちを追加
      hasOwnOrder = this.state.ownOrder.find(
        item => item.instructed_at && item.instructed_at.substring(0, subStringLength) === dateFormat
      )
      hasOtherOrder = this.state.otherOrder.find(
        item => item.instructed_at && item.instructed_at.substring(0, subStringLength) === dateFormat
      )
    }

    // 自分と自分以外が送付した日付の場合の丸ぽちの表示
    if (hasOwnOrder && hasOtherOrder) {
      return 'react-datepicker__day--highlighted-multi';
      // 自分以外が送付した日付の場合の丸ぽちの表示
    } else if (hasOtherOrder) {
      return 'react-datepicker__day--highlighted-other';
    }
  };

  render() {
    const { classes, isOpen, toggleDialog, title, user, orderList, dialogType, isExe } = this.props;
    const now = moment();
    const year = now.year();
    const minYear = 2018;
    const years = [...Array(Math.floor((year - minYear)) + 1)].map((_, i) => minYear + i);
    const january = 1;
    const february = 2;
    const march = 3;
    const april = 4;
    const may = 5;
    const june = 6;
    const july = 7;
    const august = 8;
    const september = 9;
    const october = 10;
    const november = 11;
    const december = 12;
    const months = [january, february, march, april, may, june, july, august, september, october, november, december];
    let startDays = this.createDaysArray('start');
    let endDays = this.createDaysArray('end');
    const dialogTypeText = dialogType.includes('follow_call_order') ? 'フォローコールを依頼' : 'レターを注文';

    // 送付した日付を取得
    let orderDates = [];
    if (orderList && dialogType.includes('follow_call_order')) {
      orderDates = orderList.map(item => new Date(item['created_at']))
    } else if (orderList && dialogType.includes('sent')) {
      orderDates = orderList.filter(item => (isExe ? item.is_exe === 1 : item.is_exe === 0)).map(item => new Date(item['instructed_at']))
    }

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        maxWidth="md"
        title={title}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer
        }}
      >
        <div className={classes.dateSelectContainer}>
          <div className={classes.box}>
            {this.renderSelectBox(years, '年', 'startYear')}
            {this.renderSelectBox(months, '月', 'startMonth')}
            {this.renderSelectBox(startDays, '日', 'startDay')}
          </div>
          <div className={classes.while}>
            〜
          </div>
          <div className={classes.box}>
            {this.renderSelectBox(years, '年', 'endYear')}
            {this.renderSelectBox(months, '月', 'endMonth')}
            {this.renderSelectBox(endDays, '日', 'endDay')}
          </div>
        </div>
        <ReactDatePicker
          selected={this.state.startDate ? moment(this.state.startDate).toDate() : null}
          startDate={this.state.startDate ? moment(this.state.startDate).toDate() : null}
          endDate={this.state.endDate ? moment(this.state.endDate).toDate() : null}
          onChange={this.handleChange}
          calendarClassName={'date-range-picker'} // 他で使用しているdatepickerのCSSが上書きされないようクラス名を定義
          highlightDates={orderDates} // 送付した日付に丸ぽちを追加
          dayClassName={this.addDayClassName} // チームまたは自分とチームが送付した日付に丸ぽちを追加
          monthsShown={2}
          inline
          locale="ja"
          selectsRange
          focusSelectedMonth={true}
        />
        <div className={classes.markInfo}>
          <div className={classes.flex}><span className={classes.circle} />{user.name}が{dialogTypeText}</div>
          {(user.ownership_authority_flag === 1 || user.parent_id) && (
            <div className={classes.flex} style={{ marginLeft: 25 }}>
              <span className={classes.circle} style={{ backgroundColor: '#FEC62B' }} />チームメンバーが{dialogTypeText}
            </div>
          )}
        </div>
        <div className={classes.buttonContainer}>
          <Button
            color="primary"
            onClick={() => this.handleFilter()}
            className={!this.state.startDate || !this.state.endDate ? classes.buttonDisabled : classes.button}
            disabled={!this.state.startDate || !this.state.endDate}
          >
            選択
          </Button>
        </div>
      </DialogModal>
    );
  }
}

DateRangePickerDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  dataRangeFilterSet: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  isExe: PropTypes.bool.isRequired,
  dialogType: PropTypes.string.isRequired,
  orderList: PropTypes.array,
  from: PropTypes.string,
  to: PropTypes.string,
};

export default withStyles(styles)(DateRangePickerDialog);



// WEBPACK FOOTER //
// ./src/components/common/DateRangePickerDialog.jsx